const PREFIX = 'MISC_';

const ccassConstants = {
  LIST_TUT_VID_REQUEST: PREFIX + 'LIST_TUT_VID_REQUEST',
  LIST_TUT_VID_SUCCESS: PREFIX + 'LIST_TUT_VID_SUCCESS',
  LIST_TUT_VID_FAILURE: PREFIX + 'LIST_TUT_VID_FAILURE',

  ADD_TUT_VID_REQUEST: PREFIX + 'ADD_TUT_VID_REQUEST',
  ADD_TUT_VID_SUCCESS: PREFIX + 'ADD_TUT_VID_SUCCESS',
  ADD_TUT_VID_FAILURE: PREFIX + 'ADD_TUT_VID_FAILURE',

  UPDATE_TUT_VID_REQUEST: PREFIX + 'UPDATE_TUT_VID_REQUEST',
  UPDATE_TUT_VID_SUCCESS: PREFIX + 'UPDATE_TUT_VID_SUCCESS',
  UPDATE_TUT_VID_FAILURE: PREFIX + 'UPDATE_TUT_VID_FAILURE',

  ORDER_TUT_VID_REQUEST: PREFIX + 'ORDER_TUT_VID_REQUEST',
  ORDER_TUT_VID_SUCCESS: PREFIX + 'ORDER_TUT_VID_SUCCESS',
  ORDER_TUT_VID_FAILURE: PREFIX + 'ORDER_TUT_VID_FAILURE',

  SEARCH_STOCK_REQUEST: PREFIX + 'SEARCH_STOCK_REQUEST',
  SEARCH_STOCK_SUCCESS: PREFIX + 'SEARCH_STOCK_SUCCESS',
  SEARCH_STOCK_FAILURE: PREFIX + 'SEARCH_STOCK_FAILURE',

  LIST_FAV_STOCK_REQUEST: PREFIX + 'LIST_FAV_STOCK_REQUEST',
  LIST_FAV_STOCK_SUCCESS: PREFIX + 'LIST_FAV_STOCK_SUCCESS',
  LIST_FAV_STOCK_FAILURE: PREFIX + 'LIST_FAV_STOCK_FAILURE',

  ADD_FAV_STOCK: PREFIX + 'ADD_FAV_STOCK',
  REMOVE_FAV_STOCK: PREFIX + 'REMOVE_FAV_STOCK',

  LOAD_USER_WIN_RATES_REQUEST: PREFIX + 'LOAD_USER_WIN_RATES_REQUEST',
  LOAD_USER_WIN_RATES_SUCCESS: PREFIX + 'LOAD_USER_WIN_RATES_SUCCESS',
  LOAD_USER_WIN_RATES_FAILURE: PREFIX + 'LOAD_USER_WIN_RATES_FAILURE',

  LIST_POSTS_REQUEST: PREFIX + 'LIST_POSTS_REQUEST',
  LIST_POSTS_SUCCESS: PREFIX + 'LIST_POSTS_SUCCESS',
  LIST_POSTS_FAILURE: PREFIX + 'LIST_POSTS_FAILURE',

  READ_POST: PREFIX + 'READ_POST',

  STORE_PREF_REQUEST: PREFIX + 'STORE_PREF_REQUEST',
  STORE_PREF_SUCCESS: PREFIX + 'STORE_PREF_SUCCESS',
  STORE_PREF_FAILURE: PREFIX + 'STORE_PREF_FAILURE',

  LOAD_PREF_REQUEST: PREFIX + 'LOAD_PREF_REQUEST',
  LOAD_PREF_SUCCESS: PREFIX + 'LOAD_PREF_SUCCESS',
  LOAD_PREF_FAILURE: PREFIX + 'LOAD_PREF_FAILURE',

  LIST_TUTORIALS_REQUEST: PREFIX + 'LIST_TUTORIALS_REQUEST',
  LIST_TUTORIALS_SUCCESS: PREFIX + 'LIST_TUTORIALS_SUCCESS',
  LIST_TUTORIALS_FAILURE: PREFIX + 'LIST_TUTORIALS_FAILURE',
};

export default ccassConstants;
